import React, { Component} from 'react'
import { Link } from 'react-router-dom'

class InboxInfo extends Component
{
  render() {
    return(
      <React.Fragment>
        <main>
          <div className="content">
            <section className="header-type-1">
              <h1>
                우편등기와 동일한 효력을 갖는
                <br/>
                모바일 전자등기
              </h1>
            </section>

            <section className="desc-w-bg">
              <div className="section-desc">
                <h3>
                  점점 다양해지는 온라인 발송채널,
                  <br/>
                  우편까지 한번에 보내고
                  <br/>
                  실시간으로 발송현황을 확인하실 수 있습니다.
                </h3>

                <h4 className="m-t-20">
                  전자등기부터 알림톡, 우편까지 원하는 온오프라인 발송채널을
                  <br/>
                  원하시는 순서에 따라 순차적으로 발송하실 수 있습니다.
                  <br/>
                  <span className="dis-block m-t-20">
								각 채널에 맞는 발송서식 제작으로 모바일에서도
								<br/>
								최적화된 형태로 문서를 확인할 수 있습니다.
							</span>
                </h4>
              </div>

              <div className="section-bg"></div>
            </section>
          </div>
        </main>

      </React.Fragment>
    )
  }
}

export default InboxInfo
